import { useSelector } from "react-redux";
import Home from "../../components/home/Home";
import Home2 from "../../components/home2/Home2";
import { IsAllow } from "../../utils/allowHelper/AllowHelper";
import { useGetCompanyQuery, useGetUserByIdQuery } from "store/api/apiSlice";
import { useEffect, useState } from "react";

const HomePage = () => {
  const { user } = useSelector((state) => state.user);
  const [companyAllow, setCompanyAllow] = useState([]);

  const { data: userProfile, isLoading: userLoading } = useGetUserByIdQuery(
    user.id,
    {
      skip: !user?.id,
      pollingInterval: 60000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );

  const { data: company, isLoading: companyLoading } = useGetCompanyQuery(
    userProfile?.user?.companyId,
    {
      skip: !userProfile?.user?.companyId,
    },
  );

  useEffect(() => {
    if (company?.allow) {
      setCompanyAllow({ ...company.allow });
    }
  }, [company]);

  if (userLoading || companyLoading) return null;

  return (
    <>
      {IsAllow(companyAllow, "dashboard-01") && <Home />}
      {IsAllow(companyAllow, "dashboard-02") && <Home2 />}
    </>
  );
};

export default HomePage;
